import { WorkspaceEventName, logEventV2 } from "react-migration/lib/util/logEventV2";

import ROUTES from "src/js/router/routes";
import { router } from "src/js/router/react-router";
import { setSelectedWorkspaceId } from "src/js/stores/site/actions/setSelectedWorkspaceId";

export const setSelectedWorkspace = (workspaceId: string, eventName: WorkspaceEventName) => {
  logEventV2({ name: eventName, properties: { workspaceId } });
  setSelectedWorkspaceId(workspaceId);
};

export const setSelectedWorkspaceAndNavigateToSites = (workspaceId: string, eventName: WorkspaceEventName) => {
  setSelectedWorkspace(workspaceId, eventName);
  router.push({ name: ROUTES.SITES });
};
